module.exports = __webpack_public_path__ + "assets/img/title-0876260a.png";